import { TourConfig } from '../models/tour-config.model';
import { TourFeature } from '../config/tour-feature.enum';
import { Audience } from '../config/audience.enum';
import { TourTrigger } from '../config/trigger.enum';
import { AnchorId } from '../config/anchor.registry';

/**
 * "Mehr entdecken", Teil 2 von 2 — letzte Station der Demo-Quick-Tour-Kette
 * (gestartet von `demo-discover-time-recording.config.ts` via `actions[].
 * startTour`). Endet mit derselben Registrieren-Einladung wie Station 3 der
 * Haupttour (`demo-quick-tour.config.ts`, Key wiederverwendet statt dupliziert).
 *
 * Bewusst NICHT branchenabhaengig, siehe Kopfkommentar der Schwester-Config:
 * `DemoProfileValidator.cs` erzwingt testgeprueft mindestens EINE offene
 * (`Pending`) Abwesenheitsanfrage pro Branchenprofil — das Anfragen-Panel ist
 * damit in JEDER Branche garantiert nicht leer.
 */
export const DEMO_DISCOVER_ABSENCE: TourConfig = {
  id: TourFeature.DemoDiscoverAbsence,
  version: 1,
  title: 'TUTORIAL.DEMO_DISCOVER_ABSENCE.TITLE',
  description: 'TUTORIAL.DEMO_DISCOVER_ABSENCE.DESCRIPTION',
  audience: [Audience.Admin, Audience.TeamLeader],
  triggers: [TourTrigger.Manual],
  launchContext: {
    route: '/absence',
  },
  statePolicy: {
    allowReplay: false,
    snoozeEnabled: false,
    cooldownHoursAfterDismiss: 0,
    cooldownHoursAfterSnooze: 0,
    suppressAfterCompletion: true,
  },
  priority: 5,
  estimatedDurationSec: 15,
  category: 'feature-discovery',
  chapters: [
    {
      id: 'demo-discover-absence',
      title: 'TUTORIAL.DEMO_DISCOVER_ABSENCE.TITLE',
      steps: [
        {
          id: 'absence-requests',
          anchor: AnchorId.AbsenceRequestsPanel,
          spotlightAnchor: AnchorId.AbsenceRequestsPanel,
          additionalSpotlightAnchors: [AnchorId.AbsenceCalendar, AnchorId.AbsenceCharts],
          title: 'TUTORIAL.DEMO_DISCOVER_ABSENCE.STATION.TITLE',
          content: 'TUTORIAL.DEMO_DISCOVER_ABSENCE.STATION.CONTENT',
          placement: 'right',
          nextCondition: 'manual',
          // ⚠️ Bis zum 12.09.2026 stand hier `showNextButton: false` — und das
          // ist das ENDE der gesamten Entdecker-Kette. Die Fusszeile trug dann
          // gar nichts: Wer den ganzen Weg mitgegangen war, kam nur noch ueber
          // die Registrierung oder das X heraus. Derselbe Sackgassen-Fehler wie
          // in `demo-quick-tour.config.ts` Station 3, nur eine Station spaeter —
          // und er trifft ausgerechnet die Besucher, die am weitesten gegangen
          // sind. Auf dem letzten Schritt beschriftet der Popover den
          // Weiter-Knopf selbst mit „Abschliessen".
          showNextButton: true,
          showPrevButton: false,
          showSkipButton: false,
          actions: [
            {
              labelKey: 'TUTORIAL.DEMO_QUICK_TOUR.STATION3.REGISTER_CTA',
              variant: 'primary',
              route: '/registration',
            },
          ],
        },
      ],
    },
  ],
};
